export const COMPONENT_ACTIVATION_REQUEST = 'COMPONENT_ACTIVATION_REQUEST'
export const COMPONENT_ACTIVATION_END = 'COMPONENT_ACTIVATION_END'
export const COMPONENT_ACTIVATION_START = 'COMPONENT_ACTIVATION_START'
